import { jsx as _jsx } from "react/jsx-runtime";
import { PartnerBadgeEnum } from "@/types";
import { Box } from "@gemini/core";
import { DiamondPartner } from "./PartnerBadgeTags/DiamondPartner";
import { PlatinPartner } from "./PartnerBadgeTags/PlatinPartner";
import { BusinessPartner } from "./PartnerBadgeTags/BusinessPartner";
import { PremiumPartner } from "./PartnerBadgeTags/PremiumPartner";
import { SimplePartner } from "./PartnerBadgeTags/SimplePartner";
import { PartnerBadgesModal } from "../PartnerBadgesModal";
import { useProviderSection } from "@/contexts/contact";
const badgeComponents = {
    [PartnerBadgeEnum.diamond]: DiamondPartner,
    [PartnerBadgeEnum.business]: BusinessPartner,
    [PartnerBadgeEnum.platin]: PlatinPartner,
    [PartnerBadgeEnum.simple]: SimplePartner,
    [PartnerBadgeEnum.premium]: PremiumPartner,
};
export const StandaloneBadges = ({ rootTestId, marginBottom = "spacing.16", marginTop = "spacing.8", }) => {
    var _a;
    const { badges } = (_a = useProviderSection()) !== null && _a !== void 0 ? _a : {};
    if (!(badges === null || badges === void 0 ? void 0 : badges.length))
        return null;
    return (_jsx(Box, { display: "flex", flexWrap: "wrap", gap: "spacing.8", marginTop: marginTop, marginBottom: marginBottom, children: badges === null || badges === void 0 ? void 0 : badges.map((badge) => {
            const BadgeComponent = badgeComponents[badge.title];
            if (!BadgeComponent)
                return null;
            const TriggerWrapper = ({ onPress, ...rest }) => (_jsx(Box, { cursor: "pointer", onClick: onPress, ...rest, children: _jsx(BadgeComponent, {}) }));
            return (_jsx(Box, { testId: rootTestId, children: _jsx(PartnerBadgesModal, { badges: badges, customTrigger: TriggerWrapper }) }, badge.title));
        }) }));
};
